var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"content"},[_c('Username',{attrs:{"user":_vm.message.from}}),_c('i',{staticClass:"hostmask"},[_vm._v(" ("+_vm._s(_vm.message.hostmask)+")")]),_vm._v("\n\tentrou no canal\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }